<template src="./show.html"></template>

<script>

import SchoolService from 'Services/SchoolService';

export default {
  data() {
    return {
      school: {},
    };
  },

  created() {
    this.detail();
  },

  methods: {
    ready(event) {
      this.player = event.target;
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    detail() {
      SchoolService.show(this.$route.params.id)
        .then((response) => {
          this.school = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
pre {
     text-align: justify;
     white-space: pre-line;
}
</style>
